// btw-front/src/components/sections/About.jsx
import React from "react";
import Container from "../ui/Container";
import { Fade } from "react-awesome-reveal";
import { useTranslation } from "react-i18next";

export default function About() {
  const { t } = useTranslation();

  return (
    <section id="about" className="bg-slate-100 py-12 md:py-16 lg:py-20 xl:py-24">
      <Container>
        <div className="grid gap-8 md:grid-cols-2 md:items-center">
          <Fade direction="up" triggerOnce>
            <div>
              <span className="btw-eyebrow">About</span>
              <h2 className="btw-h2 mt-4">{t("section.aboutTitle")}</h2>
              <p className="btw-lead">{t("section.aboutDesc")}</p>

              <div className="mt-8 grid gap-3 sm:grid-cols-2">
                <Info title={t("about.info.commTitle")} desc={t("about.info.commDesc")} />
                <Info title={t("about.info.maintainTitle")} desc={t("about.info.maintainDesc")} />
                <Info title={t("about.info.perfTitle")} desc={t("about.info.perfDesc")} />
                <Info title={t("about.info.securityTitle")} desc={t("about.info.securityDesc")} />
              </div>
            </div>
          </Fade>

          <Fade direction="up" triggerOnce>
            <div className="btw-card p-6 md:p-8">
              <div className="text-sm font-medium text-slate-900">{t("about.snapshotTitle")}</div>
              <div className="mt-6 grid gap-4">
                <Row label={t("about.snapshot.engineering")} value="Linux · Server · Jeus" />
                <Row
                  label={t("about.snapshot.development")}
                  value="API · Web · Application · CI/CD"
                />
                <Row label={t("about.snapshot.collab")} value="Notion · Slack · Git" />
                <Row label={t("about.snapshot.deploy")} value="Docker · GitHub Actions" />
                <Row label={t("about.snapshot.contact")} value="support@btwsoft.com" />
              </div>
              <p className="mt-6 text-xs text-slate-500">{t("about.snapshotNote")}</p>
            </div>
          </Fade>
        </div>
      </Container>
    </section>
  );
}

function Info({ title, desc }) {
  return (
    <div className="rounded-xl border border-slate-200 bg-slate-50 p-4">
      <div className="text-sm font-semibold text-slate-900">{title}</div>
      <div className="mt-2 text-sm text-slate-600">{desc}</div>
    </div>
  );
}

function Row({ label, value }) {
  return (
    <div className="flex items-center justify-between rounded-xl border border-slate-200 bg-white p-4">
      <div className="text-xs text-slate-500">{label}</div>
      <div className="text-sm font-medium text-slate-900">{value}</div>
    </div>
  );
}
